import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import css from './index.module.scss';
import GroupcA1 from './groupcA/groupcA1';
import GroupcA2 from './groupcA/groupcA2';
import GroupcB from './groupcB';
import GroupcC from './groupcC';
import GroupcD1 from './groupcD/groupcD1';
import GroupcD2 from './groupcD/groupcD2';
import GroupcD3 from './groupcD/groupcD3';
import { useGlobal } from '@/utils/useGlobal';
import { CanvasKeyFrames } from '@/utils/canvaskeyframes';
import { handleDynamicPath } from '@/utils/handleDynamicPath';
import AppPointDeltaBase from '@/components/AppPoint/DeltaBasePC';
import { SHOW_APP_POINT_SITES } from '@/constants';

gsap.registerPlugin(ScrollTrigger);

export default function Comp({}: any) {
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    const { useEffect, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_max_static');

    // 序列帧-1
    const maxIndex1 = 60;
    let canvasKeyFramesInstance1: any = null;
    const createImgs1 = (maxIndex: number) => {
        const imageEleArr: any[] = [];
        const imageCount = maxIndex;
        return new Promise((resolve, reject) => {
            let loadImageCount = 0;
            for (let i = 0; i < imageCount; i++) {
                const imageEle = new window.Image();
                imageEleArr.push(imageEle);
                imageEle.onload = function () {
                    loadImageCount++;
                    if (loadImageCount >= imageCount) {
                        // 此时图片全部加载完成
                        resolve(imageEleArr);
                    }
                };
                imageEle.onerror = reject;
                imageEle.src = handleDynamicPath(`/media/deltamax/pc/P11-P14/images/seq_1_${i}.jpg`);
            }
        });
    };

    // 序列帧-2
    const maxIndex2 = 60;
    let canvasKeyFramesInstance2: any = null;
    let preFrame2: number;
    const createImgs2 = (maxIndex: number) => {
        const imageEleArr: any[] = [];
        const imageCount = maxIndex;
        return new Promise((resolve, reject) => {
            let loadImageCount = 0;
            for (let i = 0; i < imageCount; i++) {
                const imageEle = new window.Image();
                imageEleArr.push(imageEle);
                imageEle.onload = function () {
                    loadImageCount++;
                    if (loadImageCount >= imageCount) {
                        // 此时图片全部加载完成
                        resolve(imageEleArr);
                    }
                };
                imageEle.onerror = reject;
                imageEle.src = handleDynamicPath(`/media/deltamax/pc/P11-P14/images/seq_0_${i}.jpg`);
            }
        });
    };

    // 序列帧-1
    useEffect(() => {
        // //在上一层时就触发下载
        const gsapdGroupc1: any = gsap.timeline({
            scrollTrigger: {
                trigger: '.gsapdGroupe .gsapdGroupB',
                scrub: true,
                start: `0 top`,
                end: `+=${100}`,
                once: true,
                onEnter() {
                    const container = document.querySelector('#gsapdGroupe-canvas1');
                    if (!container) return;
                    createImgs1(maxIndex1).then((imgArr) => {
                        // @ts-ignore
                        canvasKeyFramesInstance1 = new CanvasKeyFrames(container, 'array', imgArr, {
                            width: 480,
                            height: 560,
                            fps: 30,
                        });
                    });
                },
            },
        });
        gsapdGroupc1.scrollTrigger.refresh();
    }, []);

    // 序列帧-2
    useEffect(() => {
        // //在上一层时就触发下载
        const gsapdGroupc1: any = gsap.timeline({
            scrollTrigger: {
                trigger: '.gsapdGroupe .gsapdGroupB',
                scrub: true,
                start: `0 top`,
                end: `+=${100}`,
                once: true,
                onEnter() {
                    const container = document.querySelector('#gsapdGroupe-canvas2');
                    if (!container) return;
                    createImgs2(maxIndex2).then((imgArr) => {
                        // @ts-ignore
                        canvasKeyFramesInstance2 = new CanvasKeyFrames(container, 'array', imgArr, {
                            width: 480,
                            height: 386,
                            fps: 30,
                        });
                    });
                },
            },
        });
        const gsapdGroupc2: any = gsap.timeline({
            scrollTrigger: {
                trigger: '.gsapdGroupe .gsapdGroupD3',
                scrub: true,
                start: `${layoutH * 0.3} bottom`,
                end: `+=${layoutH * 0.5}`,
                onUpdate(self: any) {
                    const currentFrame = Math.floor(self.progress * (maxIndex2 - 1));
                    if (preFrame2 === currentFrame) return;
                    preFrame2 = currentFrame;
                    canvasKeyFramesInstance2 && canvasKeyFramesInstance2.goto(currentFrame);
                },
            },
        });

        gsapdGroupc1.scrollTrigger.refresh();
        gsapdGroupc2.scrollTrigger.refresh();
    }, []);

    //视频变透明
    useEffect(() => {
        const gsapdGroupc3 = gsap.timeline({
            scrollTrigger: {
                trigger: '.gsapdGroupe .gsapdGroupC',
                scrub: true,
                start: `${500} bottom`,
                end: `+=${layoutH}`,
            },
        });
        gsapdGroupc3.fromTo(
            '.gsapdGroupe .gsapdGroupC .a-img-box',
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
                ease: 'none',
            },
        );
    }, []);

    return (
        <div className={`${css.gsapdGroupe} gsapdGroupe`}>
            {t.rich('PO', {
                line1: (child: string) => <div className="a-line-1">{child}</div>,
                line2: (child: string) => <div className="a-line-2">{child}</div>,
            })}
            <GroupcA1 />
            <GroupcA2 />
            {!SHOW_APP_POINT_SITES.includes(locale) && <GroupcB />}
            {SHOW_APP_POINT_SITES.includes(locale) && (
                <div className='gsapdGroupB app-point'>
                    <AppPointDeltaBase />
                </div>
            )}
            <GroupcC />
            <GroupcD1 />
            <GroupcD2 />
            <GroupcD3 />
        </div>
    );
}
